// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__ObPpo","detailsBorder":"styles_detailsBorder__4wNgv"};